import { queryKeys } from "../queryKeys";
import { fetchAgreementPreview } from "../rest/agreements";
import useRequest, { type QueryOptions } from "./useRequest";

export const useGetAgreementPreview = ({
  accountId,
  agreement,
  options,
}: {
  accountId: string;
  agreement: string;
  options?: QueryOptions<Blob>;
}) => {
  return useRequest(
    queryKeys.agreements.preview(accountId, agreement),
    () => fetchAgreementPreview(accountId, agreement),
    {
      enabled: !!accountId && !!agreement,
      // The preview is immutable per account/agreement, so avoid re-downloading
      // (and re-minting object URLs) on background refetches.
      staleTime: Infinity,
      ...options,
    },
  );
};
